import { render, staticRenderFns } from "./GoOther.vue?vue&type=template&id=5dc4d62b&"
import script from "./GoOther.vue?vue&type=script&lang=js&"
export * from "./GoOther.vue?vue&type=script&lang=js&"
import style0 from "./GoOther.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports